import { render } from "./tw-password.vue?vue&type=template&id=76b41cdf"
import script from "./tw-password.vue?vue&type=script&lang=js"
export * from "./tw-password.vue?vue&type=script&lang=js"
script.render = render

export default script